/* index.js */

"use strict";

// const _ = require("lodash");
const ButtonControl = require("@gluenetworks/steve_ui_core").Control.Action.Button;

module.exports = {
    actionButtonsFormatter,
};

function actionButtonsFormatter(row, cell, value, columnDef, dataContext) {
    //   return (row, cell, value, columnDef /* , dataContext*/) => {
    const actions = [
        _generateButtons("View", "view", row, dataContext.commit),
        _generateButtons("Compare", "compare", row, dataContext.commit),
        _generateButtons("Apply", "apply", row, dataContext.commit),
    ];

    columnDef.width = Math.max(columnDef.width, actions.length * 60 + 10);
    return actions.map((btn) => btn.renderer.rootElement.outerHTML).join("");
    //   };
}

function _generateButtons(label, action, row, commit, disabled) {
    const btn = new ButtonControl({
        label: label,
        darkTheme: false,
        disabled: disabled,
    });
    btn.setAttribute("role", "button");
    btn.setAttribute("action", action);
    btn.setAttribute("row", row);
    btn.setAttribute("commit", commit);
    return btn;
}
